"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_module_css_1 = __importDefault(require("./Button.module.css"));
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.onClick = function (event) {
        var onClick = this.props.onClick;
        event.preventDefault();
        event.stopPropagation();
        onClick();
    };
    Button.prototype.render = function () {
        var _a = this.props, text = _a.text, disabled = _a.disabled;
        return (react_1.default.createElement("button", { className: Button_module_css_1.default.button, onClick: this.onClick.bind(this), disabled: disabled }, text));
    };
    return Button;
}(react_1.Component));
exports.Button = Button;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9EaXNjbG9zdXJlTW9kYWwvcGFydHMvQnV0dG9uL0J1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUN0QywwRUFBd0M7QUFReEM7SUFBNEIsMEJBQW9CO0lBQWhEOztJQWdCQSxDQUFDO0lBZlcsd0JBQU8sR0FBZixVQUFnQixLQUFLO1FBQ1YsSUFBQSw0QkFBTyxDQUFjO1FBQzVCLEtBQUssQ0FBQyxjQUFjLEVBQUUsQ0FBQTtRQUN0QixLQUFLLENBQUMsZUFBZSxFQUFFLENBQUE7UUFDdkIsT0FBTyxFQUFFLENBQUE7SUFDYixDQUFDO0lBRU0sdUJBQU0sR0FBYjtRQUNVLElBQUEsZUFBNkIsRUFBNUIsY0FBSSxFQUFFLHNCQUFzQixDQUFBO1FBQ25DLE9BQU8sQ0FDSCwwQ0FBUSxTQUFTLEVBQUUsMkJBQU0sQ0FBQyxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLFFBQVEsRUFBRSxRQUFRLElBQ2pGLElBQUksQ0FDQSxDQUNaLENBQUE7SUFDTCxDQUFDO0lBQ0wsYUFBQztBQUFELENBQUMsQUFoQkQsQ0FBNEIsaUJBQVMsR0FnQnBDO0FBaEJZLHdCQUFNIn0=